/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React, { memo } from 'react';
import ContentLoader, { IContentLoaderProps } from 'react-content-loader';

import { skeletonConstants } from '../constants/skeletonConstants';

export const HomePageProjectsLoader = memo<IContentLoaderProps>(props => (
  <ContentLoader
    height={153}
    width={240}
    speed={2}
    backgroundColor={skeletonConstants.backgroundColor}
    foregroundColor={skeletonConstants.foregroundColor}
    style={{
      backgroundColor: skeletonConstants.loaderBackgroundColor,
      borderRadius: '12px',
    }}
    {...props}
  >
    <rect x="22" y="40" rx="6" ry="6" width="50" height="32" />
    <rect x="95" y="40" rx="6" ry="6" width="50" height="32" />
    <rect x="168" y="40" rx="6" ry="6" width="50" height="32" />
    <rect x="22" y="20" rx="3" ry="3" width="65" height="10" />
    <rect x="25" y="104" rx="6" ry="6" width="24" height="24" />
    <rect x="56" y="108" rx="6" ry="6" width="160" height="16" />
  </ContentLoader>
));
